// Central catalog for IMOS pipeline statuses so UI stays consistent.
export const IMOS_STATUSES = [
  { key: "not_received", label: "Not Received", tone: "gray" },
  { key: "received", label: "Received", tone: "gold" },
  { key: "in_progress", label: "In Progress", tone: "gold" },
  { key: "hold", label: "Hold", tone: "amber" },
  { key: "waiting_for_update", label: "Waiting for Update", tone: "amber" },
  { key: "review", label: "Review", tone: "gold" },
  { key: "sign_off", label: "Sign-off", tone: "emerald" },
  { key: "sent_to_factory", label: "Sent to Factory", tone: "emerald" },
];

// Statuses shown in the manager's active-orders filter dropdown (excludes the
// terminal `sent_to_factory` stage since those orders move to the factory list).
export const IMOS_FILTERABLE_STATUSES = IMOS_STATUSES.filter((s) => s.key !== "sent_to_factory");

export const IMOS_STATUS_LABEL = Object.fromEntries(IMOS_STATUSES.map((s) => [s.key, s.label]));

export function statusTone(key) {
  return IMOS_STATUSES.find((s) => s.key === key)?.tone || "gray";
}

export function statusClasses(tone) {
  return ({
    gray:    "text-gray-400  border-[#262626]      bg-[#0a0a0a]",
    gold:    "text-[#d4af37] border-[#d4af37]/40   bg-[#d4af37]/5",
    amber:   "text-amber-400 border-amber-500/40   bg-amber-500/5",
    emerald: "text-emerald-400 border-emerald-500/40 bg-emerald-500/5",
  })[tone] || "text-gray-400 border-[#262626] bg-[#0a0a0a]";
}
